import { UserType } from '../@types/userRoles';

export const ROLES: Record<keyof UserType, number> = {
  SUPERADMIN: 0,
  ADMIN: 1,
  MANAGER: 2,
  DEV: 3,
  USER: 4,
  EVENTS_ADMIN: 99,
} as const;

export const EVENTS_ADMIN_ALLOWED_PATHS = ['/events'];

export function isEventsAdmin(userType?: string): boolean {
  return userType === 'EVENTS_ADMIN';
}
